<template>
  <div>
    <BreadCrumbs 
    :children="[
      {
        text: 'Cupones',
      }
    ]"/>
    <div class="card ml-15">
      <div class="card-body">
        <button class="btn main-bg mb-2" @click="_new">Nuevo</button>
        <Loader v-if="loading" />
        <div v-else  style="overflow-y:auto;max-height:60vh;">
          <table class="table">
            <thead class="thead-light">
              <th>Código</th>
              <th class="text-center">Disponible</th>
              <th class="text-center">Total</th>
              <!-- <th class="text-center">Usos</th> -->
              <th>Opciones</th>
            </thead>
            <tbody>
              <tr v-for="x in coupons" :key="x.id">
                <td>{{ x.id }}</td>
                <td class="text-center">{{ x.available ? 'Si' : 'No' }}</td>
                <td class="text-center">{{ x.total }}</td>
                <!-- <td class="text-center">{{ x.total_uses || '' }}</td> -->
                <td>
                  <a @click="edit(x)" title="Editar"><i class="fa fa-edit fa-2x text-primary mr-2"></i></a>
                  <a @click="_delete(x)" title="Eliminar"><i class="fa fa-trash fa-2x text-danger"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    <!-- MODAL -->
    <div
      class="modal fade"
      id="coupon-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="roduct-modal"
      aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            Registro de cupón
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-10">

                <div class="form-group">
                  <label for="">Código</label>
                  <input type="text" v-model="id" :readonly="onEdit === true" class="form-control" placeholder="Nombre">
                </div>  

                <div class="form-group">
                  <label for="">Total</label>
                  <input type="text" v-model="total" class="form-control"  placeholder="Total">
                </div>          
                <div class="form-group ml-1">
                  <label>Disponible</label>
                  <br />
                  <label class="switch">
                    <input type="checkbox" v-model="available" />
                    <span class="slider"></span>
                  </label>
                </div>   
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <a href="#" :disabled="saving" @click.prevent="cancel" class="text-dark mr-3">
              Cancelar
            </a>

            <button :disabled="saving" @click="save" class="btn main-bg">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

      </div>
    </div>
  </div>
</template>
<script>
import BreadCrumbs from '../components/Breadcrumbs'
import Loader from '../components/Loader'
import {CouponService} from '../../services/CouponService'

export default {
  name: 'Coupons',
  props: ['companyId'],
  components: {BreadCrumbs, Loader},
  data: function(){
    return {
      id: '',
      total: '',
      available: false,
      saving: false,
      loading: false,
      coupons: [],
      onEdit: false,
      couponService: new CouponService()
    }
  },
  methods: {
    _new(){
      this.onEdit = false;
      $('#coupon-modal').modal('show');
    },
    edit(x){
      this.onEdit = true;
      this.id = x.id;
      this.available = x.available;
      this.total = x.total;
      $('#coupon-modal').modal('show');
    },
    async _delete(x){
      const ok = await this.$helpers.confirm('Estas seguro?');
      if(ok){
        try {
          const res = await this.couponService.deleteCoupon(x.id);
          if(res.ok){
            this.$helpers.toast('Cupón eliminado!');
            this.coupons = this.coupons.filter(a => a.id !== x.id);
          }else{
            this.$helpers.message('Error',res.message, 'error');
          }
        } catch (error) {
          console.log(error);
          this.$helpers.message('Error', 'Oops, algo salio mal', 'error');
        }
      }
    },
    cancel(){
      this.id = '';
      this.available = '';
      this.total = '';
      this.onEdit = false;
      $('#coupon-modal').modal('hide');
    },
    async save(){
      if(this.id == '' || this.id.trim().length < 1){
        this.$helpers.toast('El nombre es requerido','warning'); 
        return;
      }
      const total = Number.parseFloat(this.total);
      if(this.total == '' || total < 1){
        this.$helpers.toast('El total es invalido','warning'); 
        return;
      }
      this.saving = true;

      try {
        if(this.onEdit){

          const res = await this.couponService.editCoupon(this.id, this.total, this.available);
          
          if(res.ok){
            this.$helpers.toast('Operacion exitosa!');      
          }else{
            this.$helpers.message('Error',res.message, 'error');
            return;
          }

        }else{
            
          const res = await this.couponService.addCoupon(this.id, this.total);

          if(res.ok){
            this.$helpers.toast('Operacion exitosa!');      
          }else{
            this.$helpers.message('Error',res.message, 'error');
            return;
          }

        }
        this.cancel();
        this.getCoupons();
      } catch (error) {
        console.log(error);
        this.$helpers.message('Error','Oops, al parecer algo salio mal', 'error');
      } finally{
        this.saving = false;
      }
    },
    async getCoupons(){
      this.loading = true;
      this.coupons = [];
      const res = await this.couponService.getCoupons();
      if(res.ok){
        this.coupons = res.coupons;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.loading = false;
    }
  },
  beforeMount: async function(){
    this.getCoupons();
  }
}
</script>
<style scoped>
table th, table td{
  font-weight: 500;
}
</style>